<template>
    <rkm-area
        :title="title"
        :type="type"
    >
        <rkm-row>
            <rkm-col>
                <rkm-alert
                    v-if="data.form.pacienteObservacao.pacienteAtingiu24horas"
                    color="danger"
                >
                    Paciente atingiu 24 horas em observação às {{ data.form.pacienteObservacao.tempoEmObservacao }}.
                </rkm-alert>

                <rkm-alert
                    v-else
                    color="info"
                >
                    Em observação há {{ data.form.pacienteObservacao.tempoEmObservacao }}.
                </rkm-alert>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-2">
            <rkm-col align-self="center">
                <p class="m-0 p-0">
                    <strong>Data/hora de entrada Observação:</strong> {{ data.form.pacienteObservacao.entradaObservacao }}
                </p>
            </rkm-col>

            <rkm-col cols="3">
                <strong>Quarto:</strong> {{ data.form.pacienteObservacao.quarto }}
            </rkm-col>

            <rkm-col cols="3">
                <strong>Leito:</strong> {{ data.form.pacienteObservacao.leito }}
            </rkm-col>
        </rkm-row>

        <rkm-area
            title="Trauma"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-area title="X - Exsanguinação">
                        <rkm-row>
                            <rkm-col>
                                <strong>Hemorragia externa grave:</strong>
                                    {{ data.form.pacienteObservacao.hemorragiaExternaGrave.nome || 'Não informado' }}

                                <template v-if="data.form.pacienteObservacao.hemorragiaExternaGrave.id === enums.trauma.PRESENTE">
                                    - <strong>Local:</strong> {{ data.form.pacienteObservacao.hemorragiaExternaGraveLocal }}
                                </template>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col>
                    <rkm-area title="A - Vias aéreas">
                        <rkm-row>
                            <rkm-col>
                                {{ data.form.pacienteObservacao.viasAerias.nome || 'Não informado' }}
                                <template
                                    v-if="data.form.pacienteObservacao.viasAerias.id === enums.trauma.OBSTRUCAO"
                                >
                                    <strong>Por: </strong> {{ data.form.pacienteObservacao.viasAeriasObstrucaoPor }}
                                </template>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col>
                    <rkm-area title="B - Oxigenação / Respiração / Ventilação">
                        <rkm-row>
                            <rkm-col>
                                {{ data.form.pacienteObservacao.oxigenacaoRespiracaoVentilacao.nome || 'Não informado' }}
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-area title="C - Circulação e hemorragias">
                        <rkm-row>
                            <rkm-col>
                                <rkm-list-group>
                                    <rkm-list-group-item>
                                        <strong>Pulso:</strong> {{ data.form.pacienteObservacao.pulso.nome || 'Não informado' }}
                                    </rkm-list-group-item>

                                    <rkm-list-group-item>
                                        <rkm-row>
                                            <rkm-col>
                                                <strong>Pele:</strong> {{ data.form.pacienteObservacao.pele.nome || 'Não informado' }}

                                                <template v-if="data.form.pacienteObservacao.pele.id === enums.trauma.ALTERACOES">
                                                    - {{ data.form.pacienteObservacao.peleAlteracao }}
                                                </template>
                                            </rkm-col>
                                        </rkm-row>
                                    </rkm-list-group-item>

                                    <rkm-list-group-item>
                                        <rkm-row>
                                            <rkm-col>
                                                <strong>Perfusão:</strong> {{ data.form.pacienteObservacao.perfusao.nome || 'Não informado' }}

                                                <template v-if="data.form.pacienteObservacao.perfusao.nome">
                                                    <template v-if="data.form.pacienteObservacao.perfusao.id === enums.trauma.NORMAL">
                                                        - 2 segundos
                                                    </template>
                                                    <template v-else>
                                                        - {{ data.form.pacienteObservacao.perfusaoLentificada }} segundos
                                                    </template>
                                                </template>
                                            </rkm-col>
                                        </rkm-row>
                                    </rkm-list-group-item>

                                    <rkm-list-group-item>
                                        <strong>Sangramentos:</strong> {{ data.form.pacienteObservacao.sangramento.nome || 'Não informado' }}
                                    </rkm-list-group-item>
                                </rkm-list-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col>
                    <rkm-area title="D - Avaliação neurológica">
                        <rkm-row>
                            <rkm-col>
                                <rkm-list-group>
                                    <rkm-list-group-item>
                                        <rkm-row>
                                            <rkm-col>
                                                <strong>Pupilas:</strong> {{ data.form.pacienteObservacao.pupilas.nome || 'Não informado' }}
                                            </rkm-col>
                                        </rkm-row>
                                    </rkm-list-group-item>

                                    <rkm-list-group-item>
                                        <rkm-row>
                                            <rkm-col>
                                                <strong>Paresias:</strong> {{ data.form.pacienteObservacao.paresias.nome || 'Não informado' }}
                                            </rkm-col>
                                        </rkm-row>
                                    </rkm-list-group-item>

                                    <rkm-list-group-item>
                                        <rkm-row>
                                            <rkm-col>
                                                <strong>Plegia:</strong> {{ data.form.pacienteObservacao.plegia.nome || 'Não informado' }}
                                            </rkm-col>
                                        </rkm-row>
                                    </rkm-list-group-item>
                                </rkm-list-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col>
                    <rkm-area title="E - Exposição e hipotermia">
                        <rkm-row>
                            <rkm-col>
                                {{ data.form.pacienteObservacao.exposicaoHipotermia.nome || 'Não informado' }}

                                <template v-if="data.form.pacienteObservacao.exposicaoHipotermia.id === enums.trauma.COM_LESOES">
                                    - <strong>Observação:</strong> {{ data.form.pacienteObservacao.exposicaoHipotermiaObservacao }}
                                </template>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Avaliação do trauma por partes do corpo">
            <rkm-list-group>
                <rkm-list-group-item>
                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-icon
                                id="pronto-atendimento-avaliacao-trauma-por-partes-corpo"
                                class="mr-2"
                                icon="info-circle"
                            />

                            <rkm-popover
                                target="pronto-atendimento-avaliacao-trauma-por-partes-corpo"
                                triggers="hover"
                            >
                                <div>
                                    {{ data.form.pacienteObservacao.avaliacaoCabecaPescoco.centroCusto.setor.nome }}
                                </div>
                                <div>
                                    <rkm-icon icon="user" />
                                    {{ data.form.pacienteObservacao.avaliacaoCabecaPescoco.lotacao.profissional.nome }}
                                    - {{ data.form.pacienteObservacao.avaliacaoCabecaPescoco.lotacao.ocupacao.nome }}
                                </div>
                                <div>
                                    Class. risco:
                                    {{ data.form.pacienteObservacao.avaliacaoCabecaPescoco.classificacaoRisco.nome }}
                                </div>
                            </rkm-popover>

                            {{ data.form.pacienteObservacao.avaliacaoCabecaPescoco.dataHora }}
                        </rkm-col>
                    </rkm-row>
                </rkm-list-group-item>

                <rkm-list-group-item>
                    <strong>Cabeça e Pescoço</strong> - {{ data.form.pacienteObservacao.avaliacaoCabecaPescoco.avaliacaoCabecaPescoco || 'Não informado' }}
                </rkm-list-group-item>

                <rkm-list-group-item>
                    <strong>Tórax</strong> - {{ data.form.pacienteObservacao.avaliacaoTorax || 'Não informado' }}
                </rkm-list-group-item>

                <rkm-list-group-item>
                    <strong>Abdome</strong> - {{ data.form.pacienteObservacao.avaliacaoAbdome || 'Não informado' }}
                </rkm-list-group-item>

                <rkm-list-group-item>
                    <strong>MMSS e MMII</strong> - {{ data.form.pacienteObservacao.avaliacaoMmssMmii || 'Não informado' }}
                </rkm-list-group-item>

                <rkm-list-group-item>
                    <strong>Observações</strong> - {{ data.form.pacienteObservacao.observacao || 'Não informado' }}
                </rkm-list-group-item>
            </rkm-list-group>
        </rkm-area>

        <rkm-area title="ESCALA DE COMA DE GLASGOW">
            <box-escala-coma-glasgow :data="data" />
        </rkm-area>
    </rkm-area>
</template>

<script>
// Components.
import BoxEscalaComaGlasgow from '@/components/pronto-atendimento/components/escala-coma-glasgow/List'

//Enums.
import trauma from '@/enums/pronto-atendimento/observacao/paciente-trauma'

export default {
    components:{ BoxEscalaComaGlasgow },
    data: () => ({
        enums: { trauma }
    }),
    props: {
        data: { type: Object, required: true},
        title: { type: String, default: 'PACIENTE EM OBSERVAÇÃO' },
        type: { type: String, default: 'fieldset' }
    }
}
</script>